export default {
  COUPONS:   'https://www.loom.com/share/a17992c80e6b49769078feb456abc0cc',
  ON_DEMAND: 'https://www.loom.com/share/dbbd172eba984497aeb1e11a600fdd5d',
  PACKAGES:  'https://www.loom.com/share/a7797756fef64ae7add33e845638ddb7',
  SCHEDULE:  'https://www.loom.com/share/ae3ca57c368a4f92974899daddaf39a6',
  SETTINGS:  'https://www.loom.com/share/529bf00d9bc2403ab18e2b0fcbb396f6',
  WIDGETS:   'https://www.loom.com/share/47b3ab48c6c942a482a2706160bf32a2?focus_title=1&muted=1&from_recorder=1'
};
